module.exports = __webpack_public_path__ + "img/Group 2.ddd118cd.png";